import React, { useEffect } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { datadogRum } from '@datadog/browser-rum';

function Monitor(props) {
  const flags = useFlags();

  const init = () => {
    datadogRum.init({
      // applicationId: 'de061617-a13c-4c3f-9214-4da22df7ac93',
      // clientToken: 'pub83df37fd9c96511ddf1672da40967f98',
      // site: 'us5.datadoghq.com',
      // service: 'superapp',
      applicationId: '8bad627b-2a79-4db7-9a4a-558ea7d6e7f6',
      clientToken: 'pubd25d2f9f3e0ad5eb2ea23e48857576b5',
      site: 'datadoghq.com',
      service: 'superops',
      env: 'prod',
      // Specify a version number to identify the deployed version of your application in Datadog
      // version: '1.0.0',
      sessionSampleRate: 100,
      premiumSampleRate: 100,
      trackUserInteractions: props.user?.subscriptionStatus === 'TRIAL',
      actionNameAttribute: 'stid',
      defaultPrivacyLevel: 'mask-user-input'
    });

    datadogRum.setUser({
      id: props?.user?.customerId
      // name: props?.user?.name,
      // email: props?.user?.email,
      // plan: props?.user?.chargeBeePlanId,
      // subscriptionStatus: props?.user?.subscriptionStatus,
      // userId: props?.user?.userId
    });
  };

  const start = () => {
    datadogRum.startSessionReplayRecording();
  };

  const stop = () => {
    datadogRum.stopSessionReplayRecording();
  };

  useEffect(() => {
    if (flags.sessionReplay) {
      init();
      start();
    }
  }, [flags]);

  return (
    <div style={{ display: 'none' }}>
      <div onClick={start}>start</div>
      <div onClick={stop}>stop</div>
    </div>
  );
}

export default Monitor;
